import React from 'react';
import { FiAward, FiShield, FiUsers, FiClock, FiHeart, FiStar } from 'react-icons/fi';
import './About.css';

const values = [
  {
    icon: FiAward,
    title: 'Excellence',
    description: 'Service irréprochable et attention aux détails'
  },
  {
    icon: FiShield,
    title: 'Fiabilité',
    description: 'Ponctualité garantie, véhicules entretenus'
  },
  {
    icon: FiHeart,
    title: 'Passion',
    description: 'L\'amour du service et des moments inoubliables'
  },
  {
    icon: FiUsers,
    title: 'Professionnalisme',
    description: 'Chauffeurs expérimentés et équipe dédiée'
  }
];

const achievements = [
  { icon: FiClock, number: '15', label: 'Années d\'expérience' },
  { icon: FiUsers, number: '500+', label: 'Clients satisfaits' },
  { icon: FiStar, number: '4.9/5', label: 'Note moyenne' },
  { icon: FiAward, number: '98%', label: 'Recommandations' }
];

const About = () => {
  return (
    <section className="about section-padding">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <span className="section-badge">À Propos</span>
            <h2 className="section-title">
              L'Art du Transport
              <span className="title-accent">de Luxe</span>
            </h2>

            <div className="about-description">
              <p>
                Depuis plus de 15 ans, <strong>VIP Limousine Paris</strong> incarne l'excellence
                du transport de luxe à Paris et en Île-de-France. Notre passion du service
                et notre attention aux détails font de chaque trajet une expérience mémorable.
              </p>
              <p>
                Notre flotte d'exception, nos chauffeurs professionnels en costume et notre
                disponibilité 24/7 répondent aux attentes les plus exigeantes : mariages,
                transferts aéroport, soirées VIP, EVJF, anniversaires, événements corporate.
              </p>
            </div>

            <div className="about-mission">
              <h3>Notre Mission</h3>
              <p>
                "Transformer chaque déplacement en une expérience de luxe exceptionnelle,
                alliant élégance, confort et service personnalisé."
              </p>
            </div>
          </div>

          <div className="about-stats-bar">
            {achievements.map((a, i) => {
              const Icon = a.icon;
              return (
                <div key={i} className="stat-item">
                  <Icon className="stat-icon" />
                  <span className="stat-number">{a.number}</span>
                  <span className="stat-label">{a.label}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="about-values">
          <div className="values-grid">
            {values.map((v, i) => {
              const Icon = v.icon;
              return (
                <div key={i} className="value-card">
                  <div className="value-icon">
                    <Icon size={24} />
                  </div>
                  <h4 className="value-title">{v.title}</h4>
                  <p className="value-description">{v.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
